import { Maybe } from 'graphql/jsutils/Maybe';

import { useLoyaltyOffersUiEnableOfferBadgesQuery } from 'generated/sanity-graphql';

interface IUseEnableOffersBadge {
  enableOfferBadges: Maybe<boolean>;
}

export const useEnableOffersBadge = (): IUseEnableOffersBadge => {
  const { data } = useLoyaltyOffersUiEnableOfferBadgesQuery({
    variables: {
      id: 'feature-loyalty-offers-ui-singleton',
    },
  });

  const enableOfferBadges = data?.LoyaltyOffersUI?.enableOfferBadges;

  return {
    enableOfferBadges,
  };
};
